
import http from '@/utils/http' 
import { Message } from 'element-ui';
import router from './../router'
import { getToken } from '@/utils/auth';

import store from '@/store'
export function getWebsocket() { 
  return http({
    url: '/api/sys/user/websocket',
    method: 'get',
  })
} 

const websocket = {
  serialnumber: 0,
  ws: {},
  callback: {}, 
  message: '',
  color: 'gray',
  tip: '',
  st: null,
  curSendJson: null, // 当前发送数据，不含登陆
  last_health_time: -1, // 上一次心跳时间
  setCallback(path, fun) {
    let exist = false;
    for (let key in this.callback) {
      if (path === key) {
        exist = true;
        break;
      }
    }
    if (!exist) {
      this.callback[path] = fun;
    }
  },
  setWs(newWs) {
    this.ws = newWs;
    this.ws.onopen = this.onopen;
    this.ws.onerror = this.onerror;
    this.ws.keepalive = this.keepalive; 
    let that = this;
    this.ws.onmessage = function(res) { 
      console.log(['websocket 收到数据：', res.data]) 
      websocket.message = res.data; 
      let json = JSON.parse(res.data);    
      if (json.retcode === -2) {
         // 强制退出系统 
        //  Message.error('websocket身份验证失效，请重新登录'); 
        //  setTimeout(() => {
        //     store.dispatch('LogOut').then(() => {
        //     router.push('/login')
        //     })
        //  }, 2000); 
        //  return false;
      } 
      if (json.retcode === -1001) {
        store.dispatch('SetWebSocketLogin', 0).then((res) => {});
        that.login();
      }
      // 如果是websocket登录返回
      if (json.messagecode === 1000000 && json.retcode === 0) {
        store.dispatch('SetWebSocketLogin', 1).then((res) => {});
        // 重新发送之前的json
        if (that.curSendJson != null) {
          console.log(['重新发送JSON数据到websocket']); 
          that.send(that.curSendJson);
        }
      }
    };
  },
  setColor(color) {
    this.color = color
  },
  setTip(str) {
    this.tip = str;
  },
  keepalive() {
    var time = new Date().getTime(); 
    if (
      websocket.last_health_time !== -1 &&
      time - websocket.last_health_time > 30000
    ) {
      // 不是刚开始连接并且20s
      websocket.ws.close();
    } else {
      // 如果断网了，ws.send会无法发送消息出去。ws.bufferedAmount不会为0。
      if (
        websocket.ws.bufferedAmount === 0 &&
        websocket.ws.readyState === 1
      ) { 
        websocket.ws.send('{}');
      }
    }   
    websocket.last_health_time = time;
  },
  onopen() {
    websocket.setColor('#00FF00');
    websocket.setTip('WebSocket连接成功'); 
    if (websocket.ws.readyState === 1) {
      // 为1表示连接处于open状态
      setInterval(function () {
        websocket.keepalive();
      }, 10000);
    }
  },
  send(json) {
    if (json.messagecode !== 1000000) {
      this.curSendJson = json;
    }
    websocket.serialnumber++;
    var dt = new Date(); 
    let element = Object.assign({}, json, {serialnumber: websocket.serialnumber});
    console.log(['websocket 发送数据：', JSON.stringify(element)])
    if (websocket.ws && websocket.ws.readyState === 1) {
      websocket.ws.send(JSON.stringify(element));
      return true;
    } else {
      console.log(['websocket连接未连接'])
      Message.error('websocket连接未连接'); 
      return false;
    }  
  },
  login() { 
    let that = this; 
    let wslogin = store.getters.websocketLogin;
    if (that.st !== null) {
      clearTimeout(that.st);
    }
    if (getToken() === undefined) {
       console.log(['未登录，不能登录websocket, token:', getToken()]);
    } else { 
       console.log(['websocket,websocket 状态:', this.ws.readyState]);
    }
    if (wslogin !== 1) {
      console.log(['websocket 处于账户未登录状态：', wslogin]);
    }
    
    if (wslogin !== 1) {
      if (this.ws && this.ws.readyState === 1 && getToken() !== undefined) {
        const data = {
          messagecode: 1000000,
          token: getToken()
        }; 
        this.send(data);
      }
      that.st = setTimeout(() => {
        this.login();
      }, 10000);
    }
  }
};

export default websocket



// WEBPACK FOOTER //
// ./src/api/websocket.js